import React, { useEffect } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { useAuth } from './Auth0Provider';
import { loginWithRedirect } from './Authentication';
import { IAuthAppState } from './IAuthAppState';
import { appHistory } from 'components/History';
import { getAuthConfig } from './AuthConfig';
import { rootPath } from 'components/navigation/routes';

interface IProps
{
	path: string,
	component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>,
	exact?: boolean,
	props?: JSX.ElementAttributesProperty,
}

export function PrivateRoute(props: IProps)
{
	const auth = useAuth();

	useEffect(() =>
	{
		const location = appHistory.location;
		const urlPathName = location.pathname;
		// console.log('urlPathName', urlPathName);
		// console.log('rootpath', rootPath);

		// Splitted these if statements for my own sanity... 😌

		if (!auth.setupCompleted || auth.isAuthenticated) return;
		if (!urlPathName.startsWith(props.path)) return;

		let checkRootPath = rootPath;
		// Because the default url rootpath will end with a '/', but our rootpath may not
		if (urlPathName.endsWith('/') && !checkRootPath.endsWith('/')) {
			checkRootPath += '/';
		}
		if ((props.path === rootPath || props.path === '/') && (urlPathName === checkRootPath || urlPathName === '/')) return;

		// ...if none of these are true -> we continue and redirect the user!


		// This data will be returned to the application 
		// once the authentication has been completed.
		const appState: IAuthAppState = {
			path: location.pathname,
			search: location.search,
			hash: location.hash
		};

		const config = getAuthConfig();

		// ...redirect to universal login
		loginWithRedirect({
			appState: appState,
			audience: config.audience,
			scope: config.scope,
			redirect_uri: config.redirect_uri
		});
	}, [auth.setupCompleted, auth.isAuthenticated, props.path]);

	if (auth.isAuthenticated) {
		return (
			<Route
				path={props.path}
				exact={props.exact}
				component={props.component}
				{...props.props}
			/>
		)
	} else {
		return null;
	}
}